<template>
  <div class="content">
    <spinner v-if="loading" />
    <div class="md-layout" :key="1234" v-else>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header
            class="md-card-header-icon md-card-header md-card-header-green"
          >
            <div class="card-icon">
              <md-icon>assignment</md-icon>
            </div>
            <md-button class="md-info raport-btn" @click="openRaportModal()"
              >Raport XLS
            </md-button>
          </md-card-header>
          <md-card-content>
            <md-table
              :value="queriedData"
              table-header-color="green"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-hover"
            >
              <md-table-toolbar>
                <div class="md-toolbar-section-start">
                  <md-field class="records-select">
                    <label>Na stronie</label>
                    <md-select
                      @md-selected="refreshRecords"
                      v-model="pagination.perPage"
                      name="pages"
                    >
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                        {{ item }}
                      </md-option>
                    </md-select>
                  </md-field>
                  <md-field>
                    <label>Szukaj</label>
                    <md-input v-model="searchValue" @input="searchOnTable" />
                    <md-icon>search</md-icon>
                  </md-field>
                </div>
                <md-field class="md-toolbar-section-end">
                  <label>Status</label>
                  <md-select
                    @md-selected="refreshRecords"
                    v-model="pagination.statusId"
                  >
                    <md-option value="0">
                      Wszystkie
                    </md-option>
                    <md-option
                      :key="status.status_id + Date.now()"
                      :value="status.status_id"
                      v-for="status in statuses"
                    >
                      {{ status.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </md-table-toolbar>
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ID"
                  >{{ item.offer_id }}
                </md-table-cell>
                <md-table-cell md-label="Data rejestracji" md-sort-by="date"
                  >{{ item.date | date }}
                </md-table-cell>
                <md-table-cell md-label="Imię" md-sort-by="name"
                  >{{ item.name }}
                </md-table-cell>
                <md-table-cell md-label="Nazwisko" md-sort-by="name"
                  >{{ item.surname }}
                </md-table-cell>
                <md-table-cell md-label="Telefon" md-sort-by="phone"
                  >{{ item.phone }}
                </md-table-cell>
                <md-table-cell md-label="Email" md-sort-by="email"
                  >{{ item.email }}
                </md-table-cell>
                <md-table-cell md-label="Źródlo">
                  {{ item.source }}
                </md-table-cell>
                <md-table-cell md-label="Status">
                  <md-field>
                    <md-select
                      v-model="item.status"
                      @md-selected="changeStatus(item.offer_id, item.status)"
                    >
                      <md-option
                        v-for="status in statuses"
                        :key="status.status_id + status.name"
                        :value="status.status_id"
                      >
                        {{ status.name }}
                      </md-option>
                    </md-select>
                  </md-field>
                </md-table-cell>
                <md-table-cell md-label="">
                  <drop-down>
                    <a
                      slot="title"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <md-icon>more_horiz</md-icon>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li>
                        <a href.prevent="#" @click="getRaportPdf(item.offer_id)"
                          >Wygeneruj raport</a
                        >
                      </li>
                      <li>
                        <router-link
                          :to="{
                            name: 'Podgłąd zamówienia',
                            params: {
                              id: item.offer_id,
                            },
                          }"
                          >Szczegóły
                        </router-link>
                      </li>
                      <li>
                        <a
                          v-if="canAnonymize"
                          href.prevent="#"
                          @click="anonymizeAlert(item.customer_id)"
                          >Anonimizuj</a
                        >
                      </li>
                    </ul>
                  </drop-down>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-card-actions>
            <md-card-actions md-alignment="space-between">
              <div class="">
                <p class="card-category">
                  Na stronie od {{ from + 1 }} do {{ to }} rekordów z
                  {{ pagination.total }}
                </p>
              </div>
              <pagination
                @paginationChange="refreshRecords"
                class="pagination-no-border pagination-success"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
              >
              </pagination>
            </md-card-actions>
          </md-card-actions>
        </md-card>
      </div>
    </div>
    <RaportModal ref="raportModal" />
  </div>
</template>

<script>
const toLower = text => {
  return text.toString().toLowerCase()
}

const searchByName = (items, term) => {
  if (term) {
    return items.filter(
      item =>
        toLower(item.name).includes(toLower(term)) ||
        toLower(item.surname).includes(toLower(term)) ||
        toLower(item.phone).includes(toLower(term)) ||
        toLower(item.email).includes(toLower(term))
    )
  }

  return items
}
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import RaportModal from '../../components/RaportModal'
import Pagination from '../../components/Pagination'

export default {
  components: {
    RaportModal,
    Pagination,
  },
  data() {
    return {
      selected: [],
      currentSort: 'date',
      currentSortOrder: 'desc',
      loading: true,
      searchValue: null,
      searched: [],
    }
  },
  mounted() {
    this.setup().then(() => {
      this.loading = false
      this.searchOnTable()
    })
  },
  methods: {
    refreshRecords() {
      this.loading = true
      this.$router.push({
        path: '/orders',
        query: {
          perPage: this.pagination.perPage,
          currentPage: this.pagination.currentPage,
          statusId: this.pagination.statusId,
        },
      })
      this.$store
        .dispatch('fetchOrders', {
          paginationData: this.setPagination(),
        })
        .then(() => {
          this.setPagination()
          this.searchOnTable()
          this.loading = false
        })
    },
    async setup() {
      await this.$store.dispatch('fetchOrders', {
        paginationData: this.setPagination(),
      })
      await this.$store.dispatch('fetchStatuses').catch(error => {
        this.$error(error.response)
      })
      await this.setPagination()
    },
    setPagination() {
      if (Object.keys(this.$route.query)) {
        Object.keys(this.$route.query).map(item => {
          this.pagination[item] = +this.$route.query[item]
        })
        return this.pagination
      } else {
        return this.pagination
      }
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (sortBy === 'date') {
          if (this.currentSortOrder === 'asc') {
            return new Date(a.date) - new Date(b.date)
          }
          return new Date(b.date) - new Date(a.date)
        } else {
          if (this.currentSortOrder === 'desc') {
            return a[sortBy].localeCompare(b[sortBy])
          }
          return b[sortBy].localeCompare(a[sortBy])
        }
      })
    },
    openRaportModal() {
      this.$refs.raportModal.open()
    },
    changeStatus(id, status) {
      this.$store
        .dispatch('changeStatus', {
          id,
          status,
        })
        .then(() => this.$message('Status został pomyślnie zmieniony'))
        .catch(error => this.$error(error.response.statusText))
    },
    async getRaportPdf(id) {
      const { data } = await this.$store.dispatch('getRaportPdf', {
        id,
      })
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'raport.pdf')
      document.body.appendChild(link)
      link.click()
    },
    anonymize(id) {
      this.$store
        .dispatch('anonymize', id)
        .then(() => this.$message('Klient został zanonimizowany.'))
    },
    anonymizeAlert(id) {
      Swal.fire({
        closeOnEsc: false,
        closeOnClickOutside: false,
        showCloseButton: true,
        showCancelButton: true,
        icon: 'warning',
        title: `Czy napewno chcesz zanonimizować klienta?`,
        buttonsStyling: false,
        confirmButtonClass: 'md-button md-info',
        cancelButtonText: 'Kasuj',
        cancelButtonClass: 'md-button md-danger',
      }).then(res => {
        if (res.value) {
          this.anonymize(id)
          this.searchOnTable()
        }
      })
    },
    searchOnTable() {
      this.searched = searchByName(this.allOrders, this.searchValue)
    },
  },
  computed: {
    ...mapGetters(['allOrders', 'statuses', 'canAnonymize', 'pagination']),
    queriedData() {
      let result = this.allOrders
      if (this.searched.length > 0) {
        result = this.searched
      }
      return result
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total() {
      return this.searched.length > 0
        ? this.searched.length
        : this.searched.length
    },
  },
}
</script>
<style scoped lang="scss">
.raport-btn {
  margin: 23px 0 0 auto;
}

.md-card-header {
  text-align: right;
}

.md-toolbar-section-end {
  margin-left: 20px;
}

.records-select {
  max-width: 100px;
  margin-right: 15px;
}
</style>
